import { FC, createContext, PropsWithChildren, useState, useCallback } from 'react'
import { SettingsService } from '../services'
import { ContextType } from './types'
import { initialState } from './state'
import { useAuth } from '@modules/me/hooks'

export const EmergencyContext = createContext<ContextType>({
  state: initialState,
  setEmergencyMode: () => {},
})

export const EmergencyProvider: FC<PropsWithChildren> = ({ children }) => {
  const { state } = useAuth()

  const [emergencyMode, setEmergencyMode] = useState<boolean>(() => !!state.user.data?.emergencyMode)

  const sendApiRequest = useCallback(async (mode: number) => {
    try {
      const response = await SettingsService.activation(mode)
      if (response.status === 200) window.location.reload()
    } catch (error) {
      console.error('Error updating emergency mode:', error)
    }
  }, [])

  const toggleEmergencyMode = useCallback(() => {
    const newMode = !state.user.data?.emergencyMode
    setEmergencyMode(newMode)
    sendApiRequest(newMode ? 1 : 0)
  }, [state.user, sendApiRequest])

  const contextValue: ContextType = {
    state: { emergencyMode },
    setEmergencyMode: toggleEmergencyMode,
  }

  return <EmergencyContext.Provider value={contextValue}>{children}</EmergencyContext.Provider>
}
